export default "__VITE_ASSET__NcDpEGVw__"